import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Icon } from '@millionshow/client-libs';

@Component({
  selector: 'app-philosophy',
  imports: [CommonModule, Icon],
  templateUrl: './philosophy.component.html',
})
export default class PhilosophyComponent {}
